
import TabArticles from '../TabArticles';
import SeoUtil from '../SeoUtil';


const OtherTab = () => {
  const tab_title = 'Novinky na rôzne témy'
  const url_category = 'other'

  return (<>
    <SeoUtil
      title={`Mudrosti Sveta | ${tab_title}`}
      description={tab_title}
      name='Mudrosti Sveta'
      type='articles' />
    <TabArticles tab_title={tab_title} url_category={url_category} />
  </>
  );
};

export default OtherTab;